export { default } from "./promoLanding";
